jQuery(document).ready(function($){
    $('input, .input').not('[type=file], [type=submit], [type=hidden], [type=radio], [type=checkbox]').each(function(){
        if (!$(this).parent().hasClass('control')){
            let $control = wrapWithControl($(this));
            addIcon($control);
        };
    });
});

function wrapWithControl($el) {
    let $input = $el.wrap('<div class="control"></div>');
    return $input;
}

function addIcon($input) {
    let $control = $input.parent();
    let iconClass = 'fas fa-check';
    if ($input.is('[type=date]') || $input.is('#tribe-bar-date')) {
        iconClass = "far fa-calendar-alt"
    }
    let $icon = jQuery('<span class="icon is-right"><i class="'+ iconClass +'"></i></span>');
    $control.addClass('has-icons-right').append($icon);
}